import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./page/Login";
import Dashboard from "./page/Dashboard";
import Error from "./page/Error";
import ApiConfig from "./page/ApiConfig";
import Report from "./page/Metric";
import NotificationConfig from "./page/NotificationConfig";
import Profile from "./page/Profile";
import MappingFields from "./page/MappingFields";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/error/classe" element={<Error errorType="classe-error"/>} />
          <Route path="/error/skyprep" element={<Error errorType="skyprep-error"/>} />
          <Route path="/error/app" element={<Error errorType="app-error"/>} />
          <Route path="/notification" element={<NotificationConfig />} />
          <Route path="/api_config" element={<ApiConfig />} />
          <Route path="/mapping_field" element={<MappingFields />} />
          <Route path="/metrics" element={<Report />} />
          <Route path="/view_profile" element={<Profile />} />
          <Route path="/change_password" element={<Profile />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
